const contractSigningDialogStyles = {
  paper: {
    backgroundColor: '#fff',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 900,
    width: '100%',
    margin: '0 auto',
    padding: '32px 24px 24px',
    boxSizing: 'border-box',
    '@media (max-width: 549px)': {
      padding: '24px 16px 16px',
    },
  },
  title: {
    fontWeight: 500,
    fontSize: '22px',
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 14,
    color: '#555',
    marginBottom: 4,
  },
  document: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    border: '1px solid #ddd',
    borderRadius: 4,
    backgroundColor: '#fff',
  },
  mobileDocument: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #ddd',
    borderRadius: 4,
    padding: 16,
  },
  mobileOpenButton: {
    padding: '10px 20px',
    border: '1px solid #E0726E',
    borderRadius: 4,
    color: '#E0726E',
    fontWeight: 500,
    textDecoration: 'none',
    textAlign: 'center',
  },
  openInTab: {
    alignSelf: 'flex-start',
    marginTop: 8,
    fontSize: 13,
    color: '#555',
  },
  error: {
    marginTop: 12,
    fontSize: 13,
    lineHeight: 1.5,
    color: '#E0726E',
  },
  buttonWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 16,
    marginTop: 16,
  },
  loaderWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export default contractSigningDialogStyles
